import { TooltipPosition, TooltipProps } from './types';

import UDText from 'ud-ui/components/text';
import React from 'react';
import TooltipWrapper from './tooltip-wrapper';

interface SectionTitleProps extends TooltipProps {
  title: string;
  icon?: string;
  className?: string;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ title, icon = '', className = 'mb-4', tooltip, tooltipProps }) => {
  const tooltipPosition = tooltipProps?.position || 'right';

  const renderTooltip = (position: TooltipPosition) => (
    <TooltipWrapper tooltip={tooltip} tooltipProps={{ ...tooltipProps, position }} position={position} />
  );

  return (
    <div className={`flex items-center ${className}`}>
      {tooltipPosition === 'left' && renderTooltip('left')}
      <UDText type="callout">
        {icon} {title}
      </UDText>
      {tooltipPosition === 'right' && renderTooltip('right')}
    </div>
  );
};

export default SectionTitle;
